import { useState, useEffect } from 'react'
import Card from '../components/Card'

const units = {
  kg: { name: 'Kilogram', factor: 1 },
  g: { name: 'Gram', factor: 0.001 },
  mg: { name: 'Milligram', factor: 0.000001 },
  lb: { name: 'Pound', factor: 0.453592 },
  oz: { name: 'Ounce', factor: 0.0283495 },
  st: { name: 'Stone', factor: 6.35029 },
  t: { name: 'Metric Ton', factor: 1000 },
}

export default function WeightConverter() {
  const [fromUnit, setFromUnit] = useState('kg')
  const [toUnit, setToUnit] = useState('lb')
  const [fromValue, setFromValue] = useState('')
  const [toValue, setToValue] = useState('')

  const convert = () => {
    if (!fromValue || isNaN(fromValue)) {
      setToValue('')
      return
    }

    const value = parseFloat(fromValue)
    const fromFactor = units[fromUnit].factor
    const toFactor = units[toUnit].factor

    const kilograms = value * fromFactor
    const result = kilograms / toFactor

    setToValue(result.toFixed(6).replace(/\.?0+$/, ''))
  }

  useEffect(() => {
    convert()
  }, [fromUnit, toUnit, fromValue])

  return (
    <div className="space-y-6">
      <Card>
        <Card.Body>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="label">From:</label>
              <select
                value={fromUnit}
                onChange={(e) => {
                  setFromUnit(e.target.value)
                  convert()
                }}
                className="input w-full mb-2"
              >
                {Object.entries(units).map(([key, unit]) => (
                  <option key={key} value={key}>
                    {unit.name} ({key})
                  </option>
                ))}
              </select>
              <input
                type="number"
                value={fromValue}
                onChange={(e) => {
                  setFromValue(e.target.value)
                  convert()
                }}
                className="input w-full"
                placeholder="Enter value"
                step="0.01"
              />
            </div>
            <div>
              <label className="label">To:</label>
              <select
                value={toUnit}
                onChange={(e) => {
                  setToUnit(e.target.value)
                  convert()
                }}
                className="input w-full mb-2"
              >
                {Object.entries(units).map(([key, unit]) => (
                  <option key={key} value={key}>
                    {unit.name} ({key})
                  </option>
                ))}
              </select>
              <input
                type="number"
                value={toValue}
                readOnly
                className="input w-full bg-gray-50"
                placeholder="Result"
              />
            </div>
          </div>
        </Card.Body>
      </Card>
    </div>
  )
}

